import React, { useState, useEffect, useCallback } from "react";
import {
  Grid,
  CardContent,
  CardActions,
  Divider,
  TextField,
  Box,
  Button,
  Container,
  Typography,
  Link,
} from "@material-ui/core";
import { AuthUserContext } from "../Session";
import LoadingOverlay from "react-loading-overlay";

import { withFirebase } from "../Firebase";
import PasswordDialog from "./passwordDialog";
import { useError } from "../ErrorProvider";
import { PageHeader, AppCard } from "../UI";

const DashboardSettings = (props) => (
  <AuthUserContext.Consumer>
    {(authUser) => <DashboardSettingsBase authUser={authUser} {...props} />}
  </AuthUserContext.Consumer>
);
const DashboardSettingsBase = ({ firebase, authUser }) => {
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
  const { showError, showSuccess } = useError();

  const loadData = useCallback(() => {
    setLoading(true);

    firebase.user(authUser.uid).then((val) => {
      let user = val.data();

      setEmail(user.email);
      setFirstName(user.firstName || user.username || "");
      setLastName(user.lastName || "");

      setLoading(false);
    });
  }, [firebase, authUser.uid]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const updateProfile = (event) => {
    setLoading(true);
    Promise.allSettled([
      firebase.doUpdateEmail(email),
      firebase.updateUser(authUser.uid, { firstName, lastName }),
    ]).then((results) => {
      setLoading(false);
      const failure = results.find((r) => r.status === "rejected");
      if (failure) {
        showError(failure.reason);
      } else {
        showSuccess("Profile updated.");
      }
    });

    event.preventDefault();
  };

  const openPasswordDialog = (event) => {
    setPasswordDialogOpen(true);

    event.preventDefault();
  };

  const handlePasswordCancel = () => {
    setPasswordDialogOpen(false);
  };

  const handlePasswordUpdate = (pass) => {
    setPasswordDialogOpen(false);
    setLoading(true);
    firebase
      .doPasswordUpdate(pass)
      .then((d) => {
        setLoading(false);
        showSuccess("Password updated.");
      })
      .catch((err) => {
        showError(err);
        setLoading(false);
      });
  };

  return (
    <div>
      <PageHeader title="Settings" quote="Save like a champion today" />
      <Container>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={2}
        >
          <Grid item sm={12} md={6}>
            <LoadingOverlay active={loading} spinner>
              <AppCard>
                <CardContent>
                  <Grid
                    container
                    justifyContent="center"
                    alignItems="stretch"
                    spacing={3}
                  >
                    <Grid item xs={12}>
                      <Typography variant="h4" align="center">
                        Profile
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <form onSubmit={updateProfile}>
                        <TextField
                          label="First Name"
                          placeholder="First Name"
                          name="firstName"
                          variant="outlined"
                          value={firstName}
                          onChange={(event) => setFirstName(event.target.value)}
                          fullWidth
                        />
                        <TextField
                          label="Last Name"
                          placeholder="Last Name"
                          name="lastName"
                          variant="outlined"
                          value={lastName}
                          onChange={(event) => setLastName(event.target.value)}
                          fullWidth
                        />
                        <TextField
                          label="Email"
                          placeholder="Email"
                          name="email"
                          variant="outlined"
                          value={email}
                          onChange={(event) => setEmail(event.target.value)}
                          fullWidth
                        />
                        <Button
                          fullWidth={true}
                          variant="contained"
                          color="primary"
                          type="submit"
                        >
                          Update Profile
                        </Button>
                      </form>
                    </Grid>
                  </Grid>
                </CardContent>
                <Divider orientation="horizontal" variant="fullWidth" />
                <CardActions>
                  <Box flexBasis="100%" textAlign="center">
                    <Link
                      component="button"
                      variant="body2"
                      onClick={openPasswordDialog}
                    >
                      Change Your Password
                    </Link>
                  </Box>
                </CardActions>
              </AppCard>
            </LoadingOverlay>
          </Grid>
        </Grid>
        <PasswordDialog
          open={passwordDialogOpen}
          handleCancel={handlePasswordCancel}
          handleUpdate={handlePasswordUpdate}
        />
      </Container>
    </div>
  );
};

export default withFirebase(DashboardSettings);
